// extracted by mini-css-extract-plugin
export default {"zone":"Dragover_zone__8zoG8","focus":"Dragover_focus__6OXaE"};